"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

// eslint-disable-next-line react/function-component-definition
export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  const [showModal, setShowModal] = useState(false);
  const router = useRouter();

  useEffect(() => {
    // 에러 페이지 접근 시 자동으로 signIn 페이지로 이동
    router.push("/");
  }, [router]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl font-bold mb-4">서버 에러가 발생했습니다</h1>
      <p className="text-gray-600 mb-4">
        {error.digest ? "인증이 만료되었습니다." : error.message}
      </p>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
            <h2 className="text-xl font-bold mb-4">인증 만료</h2>
            <p className="text-gray-600 mb-6">
              인증이 만료되었습니다. 다시 로그인해주세요.
            </p>
            <div className="flex justify-end">
              <button
                onClick={() => {
                  router.push("/");
                }}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                로그인 페이지로 이동
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
